import * as React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/layout/footer";
import { useQuery } from "@tanstack/react-query";
import { useMyInfo } from "../../@apis/hooks/useAuth";
import { useMyInfoStore } from "../../lib/store/useMyInfoStore";
import type { MyInfo } from "../../types/auth.types";
import { useAccessStore } from "../../lib/store/useAccessStore";
import Button from "../../components/atoms/button";
import { getZodiacImg } from "../../lib/utils/birthdayUtils";
import { useDeviceStore } from "../../lib/store/useDeviceStore";
import AppBar from "../../components/atoms/appbar";

export default function Setting() {
  const navigate = useNavigate();
  const { myInfo, setMyInfo } = useMyInfoStore();
  const { access } = useAccessStore();
  const { deviceType } = useDeviceStore();

  const { data: myInfoData, isSuccess } = useQuery({
    ...useMyInfo(),
    enabled: !!access.accessToken,
  });
  const { data, success } = myInfoData || {};

  const IS_PRODUCTION = import.meta.env.VITE_APP_MODE === "production";

  React.useEffect(() => {
    if (isSuccess && success) {
      setMyInfo(data as MyInfo);
    }
  }, [data, isSuccess, setMyInfo, success]);

  const zodiacImg = getZodiacImg(myInfo.birthdate);

  if (!access.accessToken) {
    return (
      <div className="min-h-[calc(100dvh-72px)] bg-white flex flex-col">
        <AppBar backButton title="마이페이지" />
        <section className="flex-1 flex flex-col items-center justify-center px-[15px] gap-y-[20px]">
          <p className="font-bold text-xl text-[#222]">로그인이 필요합니다.</p>
          <p className="text-[#888] text-sm text-center">
            마이페이지는 로그인 후 이용할 수 있습니다.
          </p>
          <Button
            className="rounded-full"
            variant={"black"}
            label="로그인"
            onClick={() => navigate("/login", { replace: true })}
          />
        </section>
        <Footer className="mt-auto" />
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100dvh-72px)] bg-white flex flex-col">
      <AppBar backButton title="마이페이지" />
      <section className="px-[20px] divide-y divide-[#e5e5ea]">
        <div
          className="py-[20px] cursor-pointer gap-x-[8px] flex items-center"
          onClick={() => {
            // navigate("/setting/info")
            if (deviceType !== "android") {
              navigate("/setting/info");
            } else {
              window.open("/setting/info", "_blank");
            }
          }}
        >
          {/* 프로필 사진 */}
          <div className="px-[8px] py-[4px]">
            <div className="rounded-full bg-[#f5f5f5] size-[49px] shrink-0">
              <img src={zodiacImg} alt="띠 이미지" />
            </div>
          </div>
          {/* 닉네임 */}
          <p className="text-2xl truncate font-medium flex-1">
            {myInfo.nickName}
          </p>

          <img
            className="h-4 w-auto"
            alt="내 정보 이동하기"
            src="/icons/ic-go.webp"
            role="button"
          />

          {/* <div>
            <p className="text-3xl font-bold">{myInfo.nickName}</p>
            <span className="font-[500] text-[#888] text-sm">
              {myInfo.name} /{" "}
              {parseBirth(myInfo.birthdate).format("YYYY년 MM월 DD일")} /{" "}
              {myInfo.gender == "0" ? "여성" : "남성"}
            </span>
          </div>
          <div className="rounded-full bg-[#f5f5f5] size-[66px] shrink-0">
            <img src={zodiacImg} alt="띠 이미지" />
          </div> */}
        </div>

        <div className="py-[20px]">
          <h2 className="text-[#8e8e93] font-medium text-sm mb-[16px]">
            나의 활동
          </h2>
          <div className="space-y-[12px]">
            <p
              className="font-semibold text-base"
              onClick={() => navigate("/setting/tournament-history")}
            >
              대회 접수/결제 내역
            </p>
            {(IS_PRODUCTION
              ? myInfo && ["테스트1"].includes(myInfo?.name)
              : true) && (
              <p
                className="font-semibold text-base"
                onClick={() => navigate("/setting/reservation-history")}
              >
                골프장 예약/결제 내역
              </p>
            )}
          </div>
        </div>

        <div className="py-[20px]">
          <h2 className="text-[#8e8e93] font-medium text-sm mb-[16px]">
            나의 정보 관리
          </h2>
          <div className="space-y-[12px]">
            <p
              className="font-semibold text-base"
              onClick={() => {
                // navigate("/setting/info")
                if (deviceType !== "android") {
                  navigate("/setting/info");
                } else {
                  window.open("/setting/info", "_blank");
                }
              }}
            >
              내 정보
            </p>
            <p
              className="font-semibold text-base"
              onClick={() => navigate("/setting/optional-terms")}
            >
              개인정보 동의 설정
            </p>
          </div>
        </div>

        <div className="py-[20px]">
          <h2 className="text-[#8e8e93] font-medium text-sm mb-[16px]">
            고객센터
          </h2>
          <p
            className="font-semibold text-base"
            onClick={() => navigate("/notice")}
          >
            공지사항
          </p>
        </div>
      </section>

      <Footer className="mt-auto" />
    </div>
  );
}
